// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"f019b8e7","417":"9291ea7d","433":"1428ca5e","535":"add452df","815":"715e81c8","857":"6ed43959","872":"bfd8060d"}[chunkId] + ".chunk.js";
};